import store from '../store';

export default function portalAccess({ next, router }) {
    const roles = ['owner', 'agent']
    if(!roles.includes(store.getters['roles/roles'][0])) {
        return router.push({ path: "/observatory" });
    }

    return next();
}